import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=27dd4a50&scoped=true&"
import script from "./table-list.vue?vue&type=script&lang=js&"
export * from "./table-list.vue?vue&type=script&lang=js&"
import style0 from "./table-list.vue?vue&type=style&index=0&id=27dd4a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd4a50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27dd4a50')) {
      api.createRecord('27dd4a50', component.options)
    } else {
      api.reload('27dd4a50', component.options)
    }
    module.hot.accept("./table-list.vue?vue&type=template&id=27dd4a50&scoped=true&", function () {
      api.rerender('27dd4a50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/tag-print/modules/table-list.vue"
export default component.exports